<script lang="ts">
    import {ModalDialogService} from 'shared/modal-dialogs';
    import {getInjector, getLocalization} from 'src/core';
    import type {ScalarGridValue} from 'src/features/record-grid/lib/types';
    import {type ValueFormatResponse, TEXT_VIEW_FORMAT_RESPONSE} from 'src/features/record/field-types/types';
    import {exists} from 'shared/utils/custom-utils';
    import removeMd from 'remove-markdown';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';
    import MarkdownValueDisplayModal from './MarkdownValueDisplayModal.svelte';

    export let value: ScalarGridValue;
    export let valueFormat: ValueFormatResponse | null = null;

    const modalDialogService = getInjector().getByClass(ModalDialogService);
    const localize = getLocalization();

    $: isMarkdown = exists(valueFormat) && valueFormat.type === 'text_value_format' && valueFormat.viewFormat === TEXT_VIEW_FORMAT_RESPONSE.MARKDOWN;

    const handleShowMarkdownClick = () => {
        if (typeof value.value !== 'string') {
            return;
        }

        modalDialogService.openModalWindowFromComponent<{ markdown: string }, void>(MarkdownValueDisplayModal, {
            markdown: value.value
        });
    };
</script>

{#if isMarkdown && typeof value.value === 'string'}
    <div class="markdown-value-container">
        <span class="value">{removeMd(value.value)}</span>
        <KpIconButton tooltipLabel={localize(/* @kp-localization richTextArea.editor.showButtonLabel */ 'richTextArea.editor.showButtonLabel')}
                      icon="eye"
                      buttonSize="xs"
                      on:click={handleShowMarkdownClick}/>
    </div>
{:else}
    <span>
        {value.text}
    </span>
{/if}

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .markdown-value-container {
        display: inline-flex;
        width: 100%;
        align-items: center;
        gap: @spacing-xs;

        .value {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>